module.exports = __webpack_public_path__ + "img/DA6E6E8E-8C90-4A35-A8DF-42C4FF236395.7323e8a3.png";